// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"7321fba8","118":"2879f6d5","131":"5c0a63b7","187":"d3a3a5d8","358":"e94bfa1a","367":"7a85798a","443":"8e7031ad","450":"86226c19","610":"1277be74","930":"3cfb4400","982":"4b163646"}[chunkId] + ".chunk.js";
};